const normalizeKeyPart = (value, maxLength) =>
  String(value ?? '')
    .replace(/[^\x21-\x7E]/g, '-')
    .replace(/:+/g, '-')
    .slice(0, maxLength) || 'unknown';

// Hash FNV-1a de 64 bits em duas metades. XOR e shift sem sinal são a
// definição do algoritmo, não um atalho — daí o disable localizado.
/* eslint-disable no-bitwise */
export const fingerprintMessageContent = value => {
  const input = typeof value === 'string' ? value : JSON.stringify(value);
  let firstHash = 0x811c9dc5;
  let secondHash = 0x9e3779b9;

  for (let index = 0; index < input.length; index += 1) {
    const code = input.charCodeAt(index);
    firstHash = Math.imul(firstHash ^ code, 0x01000193);
    secondHash = Math.imul(secondHash ^ code, 0x85ebca6b);
  }

  return [firstHash, secondHash]
    .map(hash => (hash >>> 0).toString(16).padStart(8, '0'))
    .join('');
};
/* eslint-enable no-bitwise */

export const createMessageBatchId = () => {
  const randomId = window.crypto?.randomUUID?.();
  const fallbackId = `${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2)}`;

  return normalizeKeyPart(randomId || fallbackId, 48);
};

export const buildMessageIdempotencyKey = ({
  scope = 'pipeline',
  batchId,
  conversationId,
  content,
}) =>
  [
    'noovi',
    normalizeKeyPart(scope, 20),
    normalizeKeyPart(batchId, 48),
    normalizeKeyPart(conversationId, 24),
    fingerprintMessageContent(content),
  ]
    .join(':')
    .slice(0, 128);
